<form [formGroup]="form">
  <ifc-base-filter-dialog [form]="form"
                          (confirmed)="onConfirmed($event)">
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Name</mat-label>
      <input matInput
             formControlName="name"
             type="text"
             placeholder="Name">
      <button type="button"
              *ngIf="form.get('name').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('name').setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Usage</mat-label>
      <mat-select matInput
                  formControlName="usage"
                  placeholder="Usage">
        <mat-option *ngFor="let u of usage"
                    [value]="u.value">{{formatUsage(u.value)}}</mat-option>
      </mat-select>
      <button type="button"
              *ngIf="form.get('usage').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('usage').setValue(null)">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Code</mat-label>
      <input matInput
             formControlName="code"
             type="text"
             placeholder="Code">
      <button type="button"
              *ngIf="form.get('code').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('code').setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>
  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>External code</mat-label>
      <input matInput
             formControlName="externalCode"
             type="text"
             placeholder="External code">
      <button type="button"
              *ngIf="form.get('externalCode').value"
              matSuffix
              mat-icon-button
              aria-label="Clear"
              (click)="form.get('externalCode').setValue('')">
        <mat-icon>close</mat-icon>
      </button>
    </mat-form-field>

  <ifb-user-fullname-input [fc]="form.get('createdBy')"
               [label]="'Created by'" baseFilterItem>
  </ifb-user-fullname-input>
  <ifc-filter-param-date-range-input [fc]="form.get('createdOn')"
                     [label]="'Created on'"
                     (rangeSelected)="createdDateSelected($event)" baseFilterItem />

    <ng-container *ngIf="form.get('createdOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('createdOnStart')"
                      [label]="'Created date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('createdOnEnd')"
                      [label]="'Created date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

  <ifb-user-fullname-input [fc]="form.get('updatedBy')"
               [label]="'Updated by'" baseFilterItem>
  </ifb-user-fullname-input>
  <ifc-filter-param-date-range-input [fc]="form.get('updatedOn')"
                     [label]="'Updated on'"
                     (rangeSelected)="updatedDateSelected($event)" baseFilterItem />

    <ng-container *ngIf="form.get('updatedOn').value === 'custom'">
      <ifc-datepicker [fc]="form.get('updatedOnStart')"
                      [label]="'Updated date from'" baseFilterItem></ifc-datepicker>
      <ifc-datepicker [fc]="form.get('updatedOnEnd')"
                      [label]="'Updated date to'" baseFilterItem></ifc-datepicker>
    </ng-container>

  <mat-form-field appearance="outline" baseFilterItem>
      <mat-label>Status</mat-label>
      <mat-select matInput
                  formControlName="active"
                  placeholder="Status">
        <mat-option>All</mat-option>
        <mat-option value="true">Active</mat-option>
        <mat-option value="false">Inactive</mat-option>
      </mat-select>
    </mat-form-field>
  </ifc-base-filter-dialog>
</form>
